import type * as ents from '@attain-apps/entities'

/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  error?: Error
  functionalizations: ents.extra.space.Functionalization[]
  isLoading: boolean
}

export namespace State {
  export const INITIAL: Readonly<State> = {
    error: undefined,
    functionalizations: [],
    isLoading: false,
  }
}
